// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1_GsM","inputWrap":"styles_inputWrap__3kSK9","input":"styles_input__2Y_4Y"};